import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import AvailableFields from './AvailableFields';
import DragDropHelpers, {replaceFieldsInHtml} from './DragDropHelpers';
import Text2BoolConverter from './Converters/Text2BoolConverter'

let counter = 0;
class ToggleInput extends Component {

    state = {
        value: undefined,
        checked: false,
        mapped: false,
        initialized: false,
        id: "toggle" + counter++
    }

    constructor() {
        super()
        this.onChange = this.onChange.bind(this)
        this.openConverter = this.openConverter.bind(this)
        this.onFieldParamsUpdated = this.onFieldParamsUpdated.bind(this)

        this.myRef = React.createRef();
        this.addFieldRef = React.createRef()
    }

    componentDidMount() {
        this.componentDidUpdate()
    }

    componentDidUpdate() {
        if (this.props.inputTypes && this.props.inputTypes.length > 0 && !this.dragDropHelpers && this.myRef) {
            this.dragDropHelpers = new DragDropHelpers(this.props.inputTypes, this.onChange, this.myRef, this.addFieldRef, true, true, ["bool", "text"], this.openConverter)

            this.myRef.current.addEventListener("drop", this.dragDropHelpers.drop)
            this.myRef.current.addEventListener("dragover", this.dragDropHelpers.dragOver)
        }

        if (this.props.value && !this.state.initialized) {
            if (this.props.value === "true") {
                this.setState({ checked: true, initialized: true })
            } else if (this.props.value === "false") {
                this.setState({ checked: false, initialized: true })
            } else {
                if (this.props.inputTypes && this.props.inputTypes.length > 0 && this.dragDropHelpers && this.myRef.current) {

                    if (this.dragDropHelpers) {
                        this.myRef.current.addEventListener("dragstart", this.dragDropHelpers.dragStartWithRemoving);
                        this.myRef.current.addEventListener("dragend", this.dragDropHelpers.dragEndWithRemoving);

                        if (this.props.value) {
                            this.dragDropHelpers.readValueAndInitializeComponents(this.props.value)
                        }
                    }

                    this.setState({ initialized: true })
                }
            }
        }
    }
    onChange = () => {
        var checked = !this.state.checked
        var mapped = false
        var html = this.myRef.current.innerHTML
        if (html !== this.lastHtml) {
            html = replaceFieldsInHtml(html)

            if (html === "") {
                html = "" + checked
            } else {
                mapped = true
            }
            this.props.onChange(html)
        }
        this.lastHtml = html

        this.setState({ checked, mapped })
    }

    openConverter = (e) => {
        this.setState({ fieldToConvert: e.target })
    }

    onFieldParamsUpdated = (params) => {
        this.state.fieldToConvert.dataset.params = btoa(unescape(encodeURIComponent(JSON.stringify(params))))
        this.onChange()
    }

    render() {
        const { t } = this.props;

        //TODO: Where should I put the converters?
        return <div>
            <Text2BoolConverter
                title={t("lbl_convert_to_bool")}
                buttonText={t("btn_done")}
                field={this.state.fieldToConvert}
                onParamsUpdated={this.onFieldParamsUpdated}
                onHide={() => this.setState({ fieldToConvert: undefined })} />
            {this.props.inputTypes && this.props.inputTypes.length > 0 ?
                <div className="custom-control custom-switch">
                    {this.state.mapped ? "" : <input type="checkbox" className="custom-control-input" id={this.state.id} onChange={this.onChange} checked={this.state.checked} />}
                    <label className="custom-control-label" htmlFor={this.state.id} ref={this.myRef}></label>
                    <button
                        id="dropdownMenuLink"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        className="icon-button field-add-button"
                        title={t("tip_field_select")}
                        style={{ "top": "0px" }}
                    ><i className="fas fa-caret-down"></i></button>

                    <div className="dropdown-menu field-selector" aria-labelledby="dropdownMenuLink" ref={this.addFieldRef} >
                        {this.dragDropHelpers ? <AvailableFields types={this.props.inputTypes} onFieldClick={this.dragDropHelpers.replaceField} dataTypes={["bool", "text"]} /> : ""}
                    </div>
                </div>
                :
                <div className="custom-control custom-switch" >
                    <input type="checkbox" className="custom-control-input" id={this.state.id} onChange={this.onChange} checked={this.state.checked} />
                    <label className="custom-control-label" htmlFor={this.state.id} ref={this.myRef}></label>
                </div>
            }

        </div>
    }
}

export default withTranslation()(ToggleInput)